export const TOKEN_COOKIE_CONFIG = {
  secure: import.meta.env.PROD, // Only secure in production (requires HTTPS)
  sameSite: "strict",
  expires: 7, // 7 days
};

export const API_URL = import.meta.env.VITE_API_URL;

// Google OAuth Configuration
export const GOOGLE_OAUTH_CONFIG = {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  redirectUri: import.meta.env.VITE_GOOGLE_REDIRECT_URI || `${window.location.origin}/admin-dashboard`,
  scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events openid',
  responseType: 'code',
  accessType: 'offline',
  prompt: 'consent'
};
